module.exports = __webpack_public_path__ + "static/img/hover-iocn11.6d55708.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn11.png
// module id = 9dO3
// module chunks = 0